<template lang="pug">
  table#tbTanquesLlegando.table.is-striped.is-responsive
    thead
      tr
        th Grupo
        th Fecha
        th Nominacion
        th Consumido
        th Porcentaje
    tbody
      tr(v-for="(d, index) in data" :key="index")
        td {{ d.subgrupo }}
        td {{ d.fecha_nominacion }}
        td {{ d.nominacion }}
        td {{ d.documentado }}
        td {{ d.porcentaje }}%
</template>

<script>
  export default {
    name: 'TbConsumos',
    props: {
      data: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/cuartocontrol/componentes/TbConsumos.vue